// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Tag = styled.span`
  ${({ theme }) => theme.typography.subTitleMedium};
  text-transform: uppercase;
  text-align: center;
  position: relative;
  color: ${({ theme }) => theme.colors.pdpTagColor};
  display: inline-block;
  margin: auto;
  font-weight: 600;
  letter-spacing: 0.9px !important;

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleSmall};
    margin: auto;
  }
`;
